import { render, staticRenderFns } from "./SelectOrganisationModal.vue?vue&type=template&id=c2c3f144&"
import script from "./SelectOrganisationModal.vue?vue&type=script&lang=js&"
export * from "./SelectOrganisationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports